import * as React from 'react';
import { useSelector } from 'react-redux';
import { useBooleanState } from '@cian/react-utils';

import { PromoCategoryModal } from '../../components/PromoCategoryModal';
import { PromoCategoryPlate } from '../../components/PromoCategoryPlate';
import { selectPageSeo } from '../../selectors/seo';
import { trackPromoCategoryPlateButtonClick } from '../../utils/analytics';

export const PromoCategoryPlateContainer: React.FC = () => {
  const { promoCategoryDetails } = useSelector(selectPageSeo);

  const { state: isModalOpen, setTrue: openModal, setFalse: closeModal } = useBooleanState(false);

  const handleButtonLinkClick = React.useCallback(() => {
    openModal();
    trackPromoCategoryPlateButtonClick();
  }, [openModal]);

  const hasModal = React.useMemo(() => {
    if (!promoCategoryDetails) {
      return false;
    }

    return promoCategoryDetails.factoids.length > 0 || promoCategoryDetails.fullDescription.length > 0;
  }, [promoCategoryDetails]);

  if (!promoCategoryDetails) {
    return null;
  }

  return (
    <>
      <PromoCategoryPlate
        onButtonLinkClick={handleButtonLinkClick}
        text={promoCategoryDetails.shortDescription}
        hasModal={hasModal}
        articleUrl={promoCategoryDetails.articleUrl}
      />
      <PromoCategoryModal
        factoids={promoCategoryDetails.factoids}
        fullDescription={promoCategoryDetails.fullDescription}
        isOpen={isModalOpen}
        onClose={closeModal}
        title={promoCategoryDetails.title}
        articleUrl={promoCategoryDetails.articleUrl}
      />
    </>
  );
};
